(function () {
    'use strict';

    angular
        .module('planInitiativeEditModule')
        .controller('InitiativeEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$location', 'historyCtxtService', 'initiative'];

    function Controller($scope, $state, $location, historyCtxtService, initiative) {
        $scope.initiative = initiative;

        $scope.hasHistoryContext = historyCtxtService.hasContext();

        $scope.goToSearchResults = function () {
            $state.go('newPlanInitiativeSearch');
        };

        $scope.createDeliverable = function () {
            $state.go('initiative.edit.addDeliverable');
        };

        $scope.goToDeliverables = function () {
            $state.go('initiative.edit.deliverable');
        };

        $scope.goToPlanInitiative = function () {
            $state.go('initiative.edit');
        };

        $scope.goToDeliverable = function (deliverable) {
            $state.go('initiative.edit.deliverable.edit', {
                PlanDeliverableID: deliverable.PlanDeliverableID
            });
        };
    }
})();